// Colour/level helpers for the four risk metrics.

export const RISK_COLORS = {
    green: { hex: "#16A34A", bg: "#DCFCE7", border: "#86EFAC", text: "#15803D" },
    yellow: { hex: "#CA8A04", bg: "#FEF9C3", border: "#FDE047", text: "#A16207" },
    orange: { hex: "#EA580C", bg: "#FFEDD5", border: "#FDBA74", text: "#C2410C" },
    red: { hex: "#DC2626", bg: "#FEE2E2", border: "#FCA5A5", text: "#B91C1C" },
};

const LEVEL_ORDER = { green: 0, yellow: 1, orange: 2, red: 3 };
export const levelRank = (l) => LEVEL_ORDER[l] ?? -1;

export const LEVEL_LABELS = {
    green: "Low",
    yellow: "Moderate",
    orange: "High",
    red: "Extreme",
};

export function fdiLevel(value, thr) {
    if (value >= thr.orange) return "red";
    if (value >= thr.yellow) return "orange";
    if (value >= thr.green) return "yellow";
    return "green";
}
export function fdiPosition(value, thr) {
    return Math.min(100, Math.max(0, (value / (thr.scale_max || 100)) * 100));
}

export function deltaTLevel(value, thr) {
    if (value < thr.green_low || value > thr.orange) return "red";
    if (value > thr.yellow) return "orange";
    if (value > thr.green_high) return "yellow";
    return "green";
}
export function deltaTPosition(value, thr) {
    const max = thr.scale_max || 16;
    return Math.min(100, Math.max(0, (value / max) * 100));
}

export function frostLevel(forecastMin, thr) {
    if (forecastMin <= thr.red) return "red";
    if (forecastMin <= thr.orange) return "orange";
    if (forecastMin <= thr.yellow) return "yellow";
    return "green";
}
export function frostPosition(forecastMin, thr) {
    const min = thr.scale_min ?? -5;
    const max = thr.scale_max ?? 8;
    const pct = ((forecastMin - min) / (max - min)) * 100;
    return Math.min(100, Math.max(0, 100 - pct)); // more risk = further right
}

export function rainLevel(mm, thr) {
    if (mm >= thr.heavy) return "green";
    if (mm >= thr.moderate) return "green";
    if (mm >= thr.light) return "yellow";
    return "orange";
}

export function sprayBadge(status) {
    if (status === "suitable") return { level: "green", label: "Suitable" };
    if (status === "marginal") return { level: "yellow", label: "Marginal" };
    return { level: "red", label: "Not suitable" };
}

export function timeAgo(iso) {
    if (!iso) return "–";
    const diff = (Date.now() - new Date(iso).getTime()) / 1000;
    if (diff < 60) return `${Math.round(diff)}s ago`;
    if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
    return `${Math.round(diff / 86400)}d ago`;
}

export function fmt(n, digits = 1, suffix = "") {
    if (n === null || n === undefined || Number.isNaN(n)) return "–";
    return `${Number(n).toFixed(digits)}${suffix}`;
}
